import { render } from "./Spinner.vue?vue&type=template&id=ff57b37e"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=ff57b37e&lang=postcss"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__